module.exports = __webpack_public_path__ + "img/admin-price-levels.e7a13f3c.png";